export default __webpack_public_path__ + "static/media/pathotrier.bca9e82b.png";